/** The account's kept simulator runs, newest first, a page at a time. */

import { useMemo } from 'react';
import { runPagesAtom, useRunPages } from '@/modules/back-testing/runs/use-run-pages';
import { simulatorRunService, type SimulatorRun, type SimulatorRunFilter } from '@/services/simulator-run.service';

/** Invalidated whenever a simulator run is kept, so an open list shows it. */
export const SIMULATOR_RUNS_QUERY_ROOT = 'simulator-runs';

const requestIdOf = (run: SimulatorRun): string => run.requestId;

export function useSimulatorRuns({ mode, userId }: SimulatorRunFilter) {
	const queryAtom = useMemo(
		() =>
			runPagesAtom([SIMULATOR_RUNS_QUERY_ROOT, mode ?? 'all', userId ?? 'everyone'], (offset, limit) =>
				simulatorRunService.fetchRuns({ mode, userId }, offset, limit)
			),
		[mode, userId]
	);
	return useRunPages(queryAtom, requestIdOf, 'Simulator runs could not be loaded.');
}
